"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Combination = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Combination"));

// Generated by script, don't edit it please.
var Combination = (0, _createSvgIcon["default"])({
  as: _Combination["default"],
  ariaLabel: 'combination',
  category: 'action',
  displayName: 'Combination'
});
var _default = Combination;
exports["default"] = _default;
module.exports = exports.default;